import { ZeitonLoader } from "components/ZeitonLoader/ZeitonLoader";

// The loading indicator inside a page or a panel, where the old spinner sat.
export function Loading() {
    return (
        <div className="fond">
            <ZeitonLoader className="fond-loader" />
        </div>
    )
}

// Opaque full-viewport loader (standard app background + centered sign). Used during app boot
// and across a tenant switch so the user sees only the loader, not the app rebuilding underneath.
export function FullScreenLoading() {
    return (
        <div className="fullscreen-loading">
            <ZeitonLoader size={120} caption />
        </div>
    )
}

export function LoadingSmallModal() {
    return (
        <div className="fond-small-modal">
            <ZeitonLoader size={44} />
        </div>
    )
}

export function LoadingButton() {
    return (
        <div className="loading-btn">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}
